export class GetSectorsWithSoilSectorUseCase  {
  constructor(sectorHasSoil) {
    this.sectorHasSoil = sectorHasSoil
  }
  async execute(IDS) {
    const resp= await this.sectorHasSoil.getByIdsFarm(IDS)

    return resp
  }
}
